import AngleBracketsIcon from "@atlaskit/icon/core/angle-brackets";
import AutomationIcon from "@atlaskit/icon/core/automation";
import BoardIcon from "@atlaskit/icon/core/board";
import BookWithBookmarkIcon from "@atlaskit/icon/core/book-with-bookmark";
import BranchIcon from "@atlaskit/icon/core/branch";
import BriefcaseIcon from "@atlaskit/icon/core/briefcase";
import BugIcon from "@atlaskit/icon/core/bug";
import CalendarIcon from "@atlaskit/icon/core/calendar";
import ChangesIcon from "@atlaskit/icon/core/changes";
import ChartBarIcon from "@atlaskit/icon/core/chart-bar";
import ChartMatrixIcon from "@atlaskit/icon/core/chart-matrix";
import ChartTrendIcon from "@atlaskit/icon/core/chart-trend";
import CheckboxCheckedIcon from "@atlaskit/icon/core/checkbox-checked";
import CommentIcon from "@atlaskit/icon/core/comment";
import DepartmentIcon from "@atlaskit/icon/core/department";
import EmojiIcon from "@atlaskit/icon/core/emoji";
import EyeOpenIcon from "@atlaskit/icon/core/eye-open";
import FilesIcon from "@atlaskit/icon/core/files";
import FormsIcon from "@atlaskit/icon/core/form";
import GoalIcon from "@atlaskit/icon/core/goal";
import InformationIcon from "@atlaskit/icon/core/information";
import ListBulletedIcon from "@atlaskit/icon/core/list-bulleted";
import LobbyBellIcon from "@atlaskit/icon/core/lobby-bell";
import MagicWandIcon from "@atlaskit/icon/core/magic-wand";
import MarketplaceIcon from "@atlaskit/icon/core/marketplace";
import MegaphoneIcon from "@atlaskit/icon/core/megaphone";
import OfficeBuildingIcon from "@atlaskit/icon/core/office-building";
import OperationsIcon from "@atlaskit/icon/core/operations";
import PageIcon from "@atlaskit/icon/core/page";
import PagesIcon from "@atlaskit/icon/core/pages";
import PersonAddedIcon from "@atlaskit/icon/core/person-added";
import PhoneIcon from "@atlaskit/icon/core/phone";
import PriorityMajorIcon from "@atlaskit/icon/core/priority-major";
import ProjectIcon from "@atlaskit/icon/core/project";
import RoadmapIcon from "@atlaskit/icon/core/roadmap";
import ScreenIcon from "@atlaskit/icon/core/screen";
import ShowMoreVerticalIcon from "@atlaskit/icon/core/show-more-vertical";
import SmartLinkListIcon from "@atlaskit/icon/core/smart-link-list";
import StarStarredIcon from "@atlaskit/icon/core/star-starred";
import TagIcon from "@atlaskit/icon/core/tag";
import TaskInProgressIcon from "@atlaskit/icon/core/task-in-progress";
import TeamsIcon from "@atlaskit/icon/core/teams";
import TimelineIcon from "@atlaskit/icon/core/timeline";
import TransitionIcon from "@atlaskit/icon/core/transition";
import WarningIcon from "@atlaskit/icon/core/warning";

interface IconMapping {
    [key: string]: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        component: any;
        version: "glyph" | "core";
    };
}

export const iconMapping: IconMapping = {
    TimelineIcon: {
        component: TimelineIcon,
        version: "core"
    },
    Calendar: {
        component: CalendarIcon,
        version: "core"
    },
    WarningIcon: {
        component: WarningIcon,
        version: "core"
    },
    TeamsIcon: {
        component: TeamsIcon,
        version: "core"
    },
    ChangesIcon: {
        component: ChangesIcon,
        version: "core"
    },
    ChartBarIcon: {
        component: ChartBarIcon,
        version: "core"
    },
    BriefcaseIcon: {
        component: BriefcaseIcon,
        version: "core"
    },
    AutomationIcon: {
        component: AutomationIcon,
        version: "core"
    },
    BugIcon: {
        component: BugIcon,
        version: "core"
    },
    DepartmentIcon: {
        component: DepartmentIcon,
        version: "core"
    },
    EyeOpenIcon: {
        component: EyeOpenIcon,
        version: "core"
    },
    BranchIcon: {
        component: BranchIcon,
        version: "core"
    },
    PhoneIcon: {
        component: PhoneIcon,
        version: "core"
    },
    CommentIcon: {
        component: CommentIcon,
        version: "core"
    },
    Page: {
        component: PageIcon,
        version: "core"
    },
    PersonAddedIcon: {
        component: PersonAddedIcon,
        version: "core"
    },
    LobbyBellIcon: {
        component: LobbyBellIcon,
        version: "core"
    },
    InformationIcon: {
        component: InformationIcon,
        version: "core"
    },
    PriorityMajorIcon: {
        component: PriorityMajorIcon,
        version: "core"
    },
    OfficeBuildingIcon: {
        component: OfficeBuildingIcon,
        version: "core"
    },
    ChartTrendIcon: {
        component: ChartTrendIcon,
        version: "core"
    },
    CheckboxCheckedIcon: {
        component: CheckboxCheckedIcon,
        version: "core"
    },
    GoalIcon: {
        component: GoalIcon,
        version: "core"
    },
    ScreenIcon: {
        component: ScreenIcon,
        version: "core"
    },
    BookWithBookmarkIcon: {
        component: BookWithBookmarkIcon,
        version: "core"
    },
    PagesIcon: {
        component: PagesIcon,
        version: "core"
    },
    ChartMatrixIcon: {
        component: ChartMatrixIcon,
        version: "core"
    },
    RoadmapIcon: {
        component: RoadmapIcon,
        version: "core"
    },
    ShowMoreVerticalIcon: {
        component: ShowMoreVerticalIcon,
        version: "core"
    },
    TagIcon: {
        component: TagIcon,
        version: "core"
    },
    MarketplaceIcon: {
        component: MarketplaceIcon,
        version: "core"
    },
    AngleBracketsIcon: {
        component: AngleBracketsIcon,
        version: "core"
    },
    ProjectIcon: {
        component: ProjectIcon,
        version: "core"
    },
    BoardIcon: {
        component: BoardIcon,
        version: "core"
    },
    MegaphoneIcon: {
        component: MegaphoneIcon,
        version: "core"
    },
    TransitionIcon: {
        component: TransitionIcon,
        version: "core"
    },
    StarStarredIcon: {
        component: StarStarredIcon,
        version: "core"
    },
    EmojiIcon: {
        component: EmojiIcon,
        version: "core"
    },

    TaskInProgressIcon: {
        component: TaskInProgressIcon,
        version: "core"
    },
    FormsIcon: {
        component: FormsIcon,
        version: "core"
    },
    FilesIcon: {
        component: FilesIcon,
        version: "core"
    },
    ListBulletedIcon: {
        component: ListBulletedIcon,
        version: "core"
    },
    SmartLinkListIcon: {
        component: SmartLinkListIcon,
        version: "core"
    },
    MagicWandIcon: {
        component: MagicWandIcon,
        version: "core"
    },
    OperationsIcon: {
        component: OperationsIcon,
        version: "core"
    }
};
